import { render, staticRenderFns } from "./account-subview.vue?vue&type=template&id=dca26f32&scoped=true&"
import script from "./account-subview.vue?vue&type=script&lang=js&"
export * from "./account-subview.vue?vue&type=script&lang=js&"
import style0 from "./account-subview.vue?vue&type=style&index=0&id=dca26f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca26f32",
  null
  
)

export default component.exports